import { LoadingOverlay, Menu, Table } from '@mantine/core';
import { IconEdit, IconTrash } from '@tabler/icons-react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { DeleteModal } from '../../../components/DeleteModal';
import { TableRowMenu } from '../../../components/TableRowMenu';
import { useModal } from '../../../hooks/useModal';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';
import { mutate } from '../../../util/api/mutate';
import { formatToCurrencyOrDefault } from '../../../util/formatting';
import { undefinedCheck } from '../../../util/undefinedCheck';
import type { BarcodeDto } from '../types/BarcodeDto';
import { EditBarcodeModal } from './EditBarcodeModal';
import { KeyedRow } from '../../../components/KeyedRow';

export function BarcodeTableRow({
	skuid,
	barcode: originalBarcode,
	triggerListUpdate,
}: { skuid: string; barcode: BarcodeDto; triggerListUpdate: () => void }) {
	const [barcode, setBarcode] = useState(originalBarcode);

	const { organisation } = useParams();

	const deleteModal = useModal();
	const editModal = useModal();

	const deleteBarcodeMutation = mutate<BarcodeDto>(
		`${organisation}/barcodes/delete/${barcode.id}`,
	);

	return (
		<>
			<DeleteModal
				close={deleteModal.close}
				isOpened={deleteModal.isOpen}
				titleType={'Barcode'}
				itemDescription={barcode.description}
				mutation={deleteBarcodeMutation}
				onComplete={() => {
					triggerListUpdate();
					deleteModal.close();
				}}
			/>
			<LoadingOverlay visible={deleteBarcodeMutation.isLoading} />
			<EditBarcodeModal
				close={editModal.close}
				isOpened={editModal.isOpen}
				updateValueInTable={(editBarcode: BarcodeDto) => {
					setBarcode(editBarcode);
				}}
				barcode={barcode}
				skuid={skuid}
			/>
			<KeyedRow>
				<Table.Td>{undefinedCheck(barcode.barcode)}</Table.Td>
				<Table.Td>{undefinedCheck(barcode.description)}</Table.Td>
				<Table.Td>{formatToCurrencyOrDefault(barcode.price)}</Table.Td>
				<Table.Td>
					<TableRowMenu>
						<Menu.Item
							leftSection={<IconEdit {...defaultIconStyle} />}
							onClick={() => editModal.open()}
							data-cy={'edit-button'}
						>
							Edit
						</Menu.Item>
						<Menu.Item
							leftSection={<IconTrash {...defaultIconStyle} />}
							c={'red'}
							onClick={() => deleteModal.open()}
						>
							Delete
						</Menu.Item>
					</TableRowMenu>
				</Table.Td>
			</KeyedRow>
		</>
	);
}
